export function sortItems(items, sortBy, sortDir) {
    const dir = sortDir === "desc" ? -1 : 1;
    return [...items].sort((a, b) => {
        const av = (a[sortBy] ?? "").toString().toLowerCase();
        const bv = (b[sortBy] ?? "").toString().toLowerCase();
        if (av < bv) return -1 * dir;
        if (av > bv) return 1 * dir;
        return 0;
    });
}